export default __webpack_public_path__ + "static/media/ClearWellness_Green.fb0ac2ad.png";